import { Component, EventEmitter, Input, Output } from '@angular/core';
import { AuDialogService } from '@core/services/au-dialog.service';
import { CmmsEntityNameComponent } from '../../../shared-form-group-controls/cmms-entity-name/cmms-entity-name.component';
import { MatRippleModule } from '@angular/material/core';
import { MatMenuModule } from '@angular/material/menu';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { IFileEntity } from '@app/pages/cmms/interfaces/files.interfaces';
import { MatTabChangeEvent, MatTabsModule } from '@angular/material/tabs';
import { NgxTolgeeModule, TranslateService } from '@tolgee/ngx';

@Component({
	selector: 'file-edit-header',
	templateUrl: './file-edit-header.component.html',
	styleUrls: ['./file-edit-header.component.scss'],
	imports: [
		CmmsEntityNameComponent,
		MatRippleModule,
		MatMenuModule,
		MatIconModule,
		MatButtonModule,
		MatTabsModule,
		NgxTolgeeModule,
	],
})
export class FileEditHeaderComponent {
	@Input() activeTab: 'view' | 'info';
	@Input() file: IFileEntity;

	@Output() replaceFilePressed = new EventEmitter<void>();
	@Output() downloadFilePressed = new EventEmitter<void>();
	@Output() deleteFilePressed = new EventEmitter<void>();
	@Output() activeTabChanged = new EventEmitter<string>();
	@Output() nameChanged = new EventEmitter<string>();

	constructor(
		private auDialogService: AuDialogService,
		private translateService: TranslateService
	) {}

	deleteFile(): void {
		const deleteText = this.translateService.instant('dialog_delete_file_description', {
			name: this.file.name,
		});
		const dialogRef = this.auDialogService.openDeleteDialog({
			itemType: 'file',
			description:
				this.file.locations.length > 1
					? `${deleteText} <br> 
				${this.translateService.instant('dialog_delete_file_linked_locations_warning')}`
					: deleteText,
		});

		this.auDialogService.closedByEnter(dialogRef).subscribe((confirm: boolean) => {
			if (confirm) {
				this.deleteFilePressed.emit();
			}
		});
	}

	updateFileEntityName($event: { name: string }) {
		if (this.nameHasChanged($event.name)) {
			this.nameChanged.emit($event.name);
		}
	}

	tabChanged($event: MatTabChangeEvent) {
		const activeTab = $event.index === 0 ? 'view' : 'info';
		this.activeTabChanged.emit(activeTab);
	}

	private nameHasChanged(nameToCheck: string): boolean {
		return this.file.name.trim() !== nameToCheck.trim();
	}
}
